import {Component, HostListener, OnInit} from '@angular/core';
import {ThemeOptions} from '../../../theme-options';
import {select} from '@angular-redux/store';
import {Observable} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ServiceService } from "src/app/services/service.service";

import { Router } from "@angular/router";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit {
  public extraParameter: any;
  user_id: any;
  user_permission: any;
  api_version: any;
  client_id: any;
  nas_id: any;
  ps_key: any;
  userdetails: any;
  user_firstname: any;
  user_lastname: any;
  user_number: any;

  constructor(public globals: ThemeOptions, private activatedRoute: ActivatedRoute,private http: HttpClient,
      private router: Router,
      private ServerService: ServiceService) {

  }

  @select('config') public config$: Observable<any>;

  private newInnerWidth: number;
  private innerWidth: number;
  activeId = 'dashboardsMenu';

  toggleSidebar() {
    this.globals.toggleSidebar = !this.globals.toggleSidebar;
  }

  sidebarHover() {
    this.globals.sidebarHover = !this.globals.sidebarHover;
  }

  ngOnInit() {
    this.user_permission = localStorage.getItem('user_id');
    this.user_id = localStorage.getItem('user_name');
    this.api_version = localStorage.getItem('api_version');
    this.client_id = localStorage.getItem('client_id');
    this.nas_id = localStorage.getItem('nas_id');
    this.ps_key = localStorage.getItem('ps_key');
    setTimeout(() => {
      this.innerWidth = window.innerWidth;
      if (this.innerWidth < 1200) {
        this.globals.toggleSidebar = true;
      }
    });
    this.postData();

    this.extraParameter = this.activatedRoute.snapshot.firstChild?.data?.extraParameter;


  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.newInnerWidth = event.target.innerWidth;

    if (this.newInnerWidth < 1200) {
      this.globals.toggleSidebar = true;
    } else {
      this.globals.toggleSidebar = false;
    }

  }


   postData() {
      const body = new HttpParams()
        // .set("api_version", this.api_version )
        // .set("client_id", this.client_id)
        // .set("ps_key", this.ps_key)
        // .set("nas_id",this.nas_id)
        .set("action_id", "get_user_record")
        .set("action", "get_url")
        .set(
          "req_params",
          JSON.stringify({ req_id: "string", user_id: this.user_id })
        );
  
      // Set headers
      const headers = new HttpHeaders({
        "Content-Type": "application/x-www-form-urlencoded"
      });
  
      this.ServerService.sendServer2(body.toString(), headers).subscribe(
        (response: any) => {
  
          if (response) {
            this.user_firstname = response.results.first_name.toUpperCase(); 
            this.user_lastname = response.results.last_name.toUpperCase(); 
            this.user_number = response.results.user_id; 
          } else {
            
          }
        },
        (error) => {
          console.error("API Error:", error);
        }
      );
    }





}
